/** Catalogue limits rendered as centimetres. Explicit MM is always divided.
 * Print.com labels its custom sizes "CM" while the numbers are millimetres
 * (Foto op Forex: 50-3010, Blackback up to 50000). Read as centimetres, nobody
 * could order Forex under 50 cm and 30 m was accepted (16-10-2026). Every live
 * "CM" record has values above 300, no record from another supplier does, so
 * above 300 the label is ignored, exactly like the unitless heuristic. */
export function normalizeCustomSizeLimits(customSizes: {
  minWidth?: unknown; maxWidth?: unknown; minHeight?: unknown; maxHeight?: unknown; sizeUnit?: unknown;
} | null | undefined) {
  const numbers = [customSizes?.minWidth, customSizes?.maxWidth, customSizes?.minHeight, customSizes?.maxHeight]
    .map((value) => Number(value));
  const unit = String(customSizes?.sizeUnit || '').trim().toUpperCase();
  const largest = Math.max(...numbers.map((value) => Number.isFinite(value) ? value : 0));
  const divisor = unit === 'MM' || largest > 300 ? 10 : 1;
  const values = numbers.map((value) => Number.isFinite(value) && value > 0 ? value / divisor : undefined);
  return { minWidth: values[0], maxWidth: values[1], minHeight: values[2], maxHeight: values[3] };
}
